import axios from 'axios';
import NProgress from 'nprogress';
import { message } from 'antd';

import 'nprogress/nprogress.css';

let navigate;

export const setNavigate = (nav) => {
    navigate = nav;
};

// Cấu hình NProgress
NProgress.configure({
    showSpinner: false,
    trickleSpeed: 100,
});

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://apijob.nguyenluan.vn/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor để thêm accessToken vào tất cả các request
api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        NProgress.start(); // Bắt đầu thanh tiến trình khi yêu cầu được gửi
        return config;
    },
    (error) => {
        NProgress.done(); // Ẩn thanh tiến trình khi gặp lỗi request
        return Promise.reject(error);
    }
);

// Interceptor để refresh token khi gặp lỗi 401
api.interceptors.response.use(
    (response) => {
        NProgress.done(); // Ẩn thanh tiến trình khi nhận được phản hồi thành công
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        // Kiểm tra lỗi 401 và 403, tránh retry nhiều lần
        if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem('refreshToken');
            if (!refreshToken) {
                // Nếu không có refresh token, yêu cầu đăng nhập lại
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                message.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.');
                if (navigate) navigate('/login');
                error.handled = true;
                return Promise.reject(new Error('No refresh token available'));
            }

            try {
                // Gọi API để làm mới token
                const response = await api.post('/auth/refresh-token', { refreshToken });
                console.log('accessToken', response);

                // Lưu accessToken mới vào localStorage
                localStorage.setItem('accessToken', response.data.accessToken);

                // Thêm token mới vào headers của request và thử lại request
                originalRequest.headers['Authorization'] = `Bearer ${response.data.accessToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                // Nếu gặp lỗi khi refresh token
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                message.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.');
                if (navigate) navigate('/login');
                refreshError.handled = true;
                return Promise.reject(refreshError);
            }
        }

        NProgress.done(); // Ẩn thanh tiến trình khi gặp lỗi phản hồi
        return Promise.reject(error);
    }
);

export default api;
